<div class="d-flex row mr-0 -total-cell">
  <div class="-half-column -left">
    <ng-container *ngIf="data.subType === 'money'; else dynamic">
      <gtd-ui-field-default-money [data]="data.delta" [currencyCode]="data.currencyCode"></gtd-ui-field-default-money>
    </ng-container>
    <ng-template #dynamic>
      <gtd-ui-field-dynamic [data]="data.delta" [type]="data.subType"></gtd-ui-field-dynamic>
    </ng-template>
  </div>
  <div class="-half-column -right">
    <gtd-ui-field-default-comparing-percentage [data]="data.absolute"></gtd-ui-field-default-comparing-percentage>
  </div>
</div>
